import { Route, Routes, useLocation } from "react-router-dom"
import Layout from "./components/Layout"
import { AnimatePresence } from "framer-motion"

import "./App.css"
import "./General.css"
import "./Scroll.css"
import Home from "./pages/Home"
import Work from "./pages/Work"
import Locomotive from "./Locomotive"
import Cursor from "./components/Cursor"
import useWindowsWidth from "./hooks/useWindowsWidth"
import Works from "./pages/Works"
import About from "./pages/About"
import LoadingScreen from "./components/LoadingScreen"

function App() {
  const [width] = useWindowsWidth()
  const location = useLocation()

  return (
    <>
      <LoadingScreen />
      {width > 768 ? <Cursor /> : null}
      <AnimatePresence mode="wait" initial={false}>
        <Routes key={location.pathname} location={location}>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route element={<Locomotive />}>
              <Route path="/about" element={<About />} />
              <Route path="/work/">
                <Route path="all" exact element={<Works />} />
                <Route path=":id" element={<Work />} />
              </Route>
            </Route>
          </Route>
        </Routes>
      </AnimatePresence>
    </>
  )
}

export default App
